import type { ReactNode } from "react";
import { useIdCopy } from "@hooks/useIdCopy";
import styles from "./AvatarCopyId.module.scss";

interface AvatarCopyIdProps {
    id: string | number;
    /** What the ID belongs to, e.g. "Entity" in "Entity ID copied". */
    label: string;
    children: ReactNode;
}

/**
 * Wraps an avatar so a right-click copies its database ID, when the
 * `showDbIds` flag is on. Only rendered for avatars given a `copyId`, so plain
 * avatars do not read the flags.
 */
export const AvatarCopyId = ({ id, label, children }: AvatarCopyIdProps) => {
    const { getCopyProps } = useIdCopy({ label });

    return (
        <span className={styles.target} {...getCopyProps(id)}>
            {children}
        </span>
    );
};
